import React from 'react';
import I18n from 'i18n-js';
import CoreClient from '../lib/core_client';
import UrlHelpers from './shared/url_helpers';
import CSPReviewButton from './csp/components/csp_review_button';
import { ProductReviewCreateResult } from './ProductReviewsHeader';
import { ProductReviewCSPFields } from '../schemas/rql';

interface Props {
  onResponse(data: ProductReviewCreateResult): void;
  csp: ProductReviewCSPFields.Fragment;
  trackingDisplayStyle: 'product' | 'csp';
}

export function ProductReviewFormButton(props: Props) {
  const { onResponse, csp, trackingDisplayStyle } = props;

  function onSubmit(data) {
    let apiCall;

    if (csp.myReview) {
      apiCall = CoreClient.put(UrlHelpers.cspUpdateReviewUrl(csp.myReview.id), data);
    } else {
      apiCall = CoreClient.post(UrlHelpers.cspReviewsUrl(csp.slug, null, null), data);
    }

    const apiResponse = apiCall.then(() => {
      onResponse({ alertType: 'success', message: I18n.t('discovery.productReviews.header.successMessage') });
    }).catch((e) => {
      onResponse({ alertType: 'error', message: errorMessage(e) });
    });

    return apiResponse;
  }

  function errorMessage(error) {
    if (error.data.errors.rating) {
      return I18n.t('discovery.productReviews.header.errorMessage.rating');
    }

    return I18n.t('discovery.productReviews.header.errorMessage.body');
  }

  return (
    <>
      <CSPReviewButton
        onSubmit={onSubmit}
        productTitle={csp.title}
        myReview={csp.myReview}
        cspId={csp.id}
        trackingDisplayStyle={trackingDisplayStyle}
      />
    </>
  );
}
